<script lang="ts" setup>
import { fetchSubSourceList, fetchSubTemplateFields } from "@/api/template";
import { computed, onMounted, reactive, ref, nextTick } from "vue";
import { Search } from "@element-plus/icons-vue";
import { message } from "@/utils/message";

const props = defineProps({
  code: String
});

const emit = defineEmits(["choose"]);

const tableData = ref([]);
const fields = ref([]);
const keywords = ref("");
const current = ref("");
const query = ref({});
const pager = reactive({
  page: 1,
  pageNum: 100,
  total: 0
});
const filterFields = computed(() => {
  return fields.value.filter(
    item => !["id", "user_id", "created_at", "updated_at"].includes(item.Field)
  );
});
const onSearch = () => {
  if (keywords && fields.value.length > 0) {
    if (!current.value) {
      message("请选择搜索字段", { type: "warning" });
      return;
    }
    let newQuery = {
      [current.value]: keywords
    };
    query.value = newQuery;
  } else {
    query.value = {};
  }
  nextTick(queryList);
};
const list = computed(() => {
  let extraKeys = ["id", "user_id", "user_name", "created_at", "updated_at"];
  return tableData.value.map(item => {
    let keys = Object.keys(item);
    let subArr = [];
    keys.forEach(key => {
      if (extraKeys.includes(key)) return;
      let findItem = fields.value.find(field => {
        return field.Field === key;
      });
      subArr.push({
        name: findItem ? findItem.Comment : key,
        value: item[key]
      });
    });
    return subArr;
  });
});

// 查询列表
const queryList = () => {
  if (!props.code) return;
  fetchSubSourceList({
    ...query.value,
    page: pager.page,
    pageNum: pager.pageNum,
    code: props.code
  }).then(res => {
    if (res.success) {
      tableData.value = res.data.list.slice(0, 10);
      pager.total = res.data.total;
    }
  });
};

const initCurrent = () => {
  if (filterFields.value.length === 0) return;
  current.value = filterFields.value[0].Field;
};

const queryFileds = () => {
  if (!props.code) return;
  fetchSubTemplateFields(props.code).then(res => {
    if (res.success) {
      fields.value = res.data;
      nextTick(initCurrent);
    }
  });
};
const chooseItem = (item: any) => {
  let extraKeys = ["id", "user_id", "user_name", "created_at", "updated_at"];
  const newItem: any = {};
  const keys = Object.keys(item);
  keys.forEach(key => {
    if (extraKeys.includes(key)) return;
    newItem[key] = item[key];
  });
  emit("choose", newItem);
};
onMounted(() => {
  queryFileds();
  queryList();
});
</script>
<template>
  <div>
    <div class="mb-4">
      <el-input class="input-with-select" v-model="keywords" placeholder="输入关键词搜索" size="large">
        <template #prepend>
          <el-select v-model="current" placeholder="搜索字段" style="width: 115px" size="large">
            <el-option v-for="item in filterFields" :key="item.Field" :label="item.Comment" :value="item.Field" />
          </el-select>
        </template>
        <template #append>
          <el-button @click="onSearch" type="primary" :icon="Search" />
        </template>
      </el-input>
    </div>
    <template v-if="list.length > 0">
      <div v-for="(item, index) in list" :key="index" class="rounded-xl bg-gray-100 px-4 py-2 mb-4 cursor-pointer"
        @click="chooseItem(tableData[index])">
        <div v-for="(subitem, subindex) in item" :key="subindex" class="my-2 flex text-gray-800 leading-5"
          v-show="subindex <= 3">
          <div class="font-bold" style="max-width: 7em">
            {{ subitem.name }}：
          </div>
          <el-image v-if="/^http.*([\.png|\.jpg|\.jpeg])$/.test(subitem.value)" style="width: 100px; height: 100px"
            :src="subitem.value" fit="contain" />
          <div class="ml-1 flex-1 w-0" v-else>{{ subitem.value }}</div>
        </div>
      </div>
    </template>
    <el-empty v-else :image-size="100" description="暂无数据" />
  </div>
</template>
<style lang="scss" scoped>
.input-with-select {
  ::v-deep(.el-input-group__prepend) {
    background-color: var(--el-fill-color-blank);
  }
}
</style>
